export default {
  siteName: '拔插指南',
  siteDescription: '设备接口拔插操作完整指南',
  nav: {
    home: '首页',
    categories: '分类',
    about: '关于我们',
  },
  footer: {
    brandIntro: '拔插指南是专注于设备接口拔插操作的专业知识平台，致力于为用户提供正确、安全、高效的拔插操作指导。',
    quickLinks: '快速链接',
    categories: '文章分类',
    contactUs: '联系我们',
    email: 'contact@bachabacha.com',
    copyright: '© 2026 拔插指南. All rights reserved.',
  },
  home: {
    heroTitle: '拔插拔插',
    heroSubtitle: '让每一次连接都精准到位',
    heroDesc: '掌握正确的拔插手法，延长设备寿命，避免接触不良与硬件损坏',
    startReading: '开始阅读指南',
    viewCategories: '浏览分类',
    featuredArticles: '精选文章',
    allArticles: '查看全部文章',
    faqTitle: '常见问题解答',
    faqSubtitle: '关于拔插拔插，你最关心的都在这里',
    ctaTitle: '准备好提升你的拔插技巧了吗？',
    ctaSubtitle: '从基础手法到进阶技巧，一份指南全搞定。',
    ctaButton: '立即开始学习',
    categoriesTitle: '探索分类',
    categoriesSubtitle: '六大专题，系统学习拔插知识',
  },
  category: {
    title: '分类',
    articleCount: '篇文章',
    noArticles: '该分类下暂无文章',
    allCategories: '全部分类',
  },
  article: {
    author: '作者',
    publishedAt: '发布于',
    readTime: '阅读时长',
    minRead: '分钟',
    relatedArticles: '相关文章',
    tableOfContents: '目录',
    tags: '标签',
  },
  about: {
    title: '关于我们',
    subtitle: '专注拔插知识，守护设备安全',
    brandIntro: '品牌介绍',
    brandDesc1: '拔插指南成立于2024年，是国内首个专注于设备接口拔插操作的垂直知识平台。我们的使命是帮助每一位用户掌握正确的拔插手法，在保障设备安全的同时提升操作效率。',
    brandDesc2: '拔插拔插看似简单，实则蕴含着丰富的工程学原理和安全知识。从USB到HDMI，从电源接口到内部硬件，每一次拔插操作都关系到设备的寿命和数据的安全。',
    brandDesc3: '我们汇聚了来自硬件工程、电子维修、产品设计等领域的专业作者，为用户提供经过验证的、实用的拔插操作指南。所有内容都基于实际测试和行业标准，确保信息的准确性和可靠性。',
    reputation: '用户口碑',
    contactTitle: '联系我们',
    contactDesc: '有任何关于拔插操作的疑问或建议？欢迎通过以下方式联系我们，我们会在24小时内回复。',
    contactForm: '发送消息',
    name: '姓名',
    email: '邮箱',
    message: '留言内容',
    submit: '提交',
    submitSuccess: '发送成功！我们会尽快回复您。',
    submitError: '发送失败，请稍后重试或直接发送邮件联系我们。',
    address: '地址',
    addressValue: '中国广东省深圳市南山区科技园',
  },
  breadcrumb: {
    home: '首页',
  },
  scrollToTop: '回到顶部',
};